/* Hogara Ritual — sugerencia de las zapatillas dentro del carrito (cajón y página).
   Aparece si hay un pijama en el carrito y aún no hay zapatillas. "No" la oculta
   hasta que en el carrito ya no quede ningún pijama (al vaciarlo y volver a añadir
   un pijama, sale otra vez); "Sí" pide color y talla; "Información" enseña
   colores y tallas. */
(function () {
  'use strict';
  if (window.__hrSugerencia) return;
  window.__hrSugerencia = true;

  var KEY = 'hrs-no';
  var cfg = null;
  var card = null;
  var busy = false;
  var queued = false;
  var timer = null;

  function readCfg() {
    var el = document.getElementById('hrs-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function dismissed() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function dismiss() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* sin almacenamiento: solo se oculta ahora */ }
  }
  function undismiss() {
    try { sessionStorage.removeItem(KEY); } catch (e) { /* nada */ }
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function button(cls, text) {
    var b = el('button', 'hrs__btn ' + cls, text);
    b.type = 'button';
    return b;
  }

  function buildCard() {
    var t = cfg.texts || {};
    var box = el('div', 'hrs');
    box.setAttribute('data-hrs', '');
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', t.question || '');

    var row = el('div', 'hrs__row');
    if (cfg.image) {
      var img = el('img', 'hrs__img');
      img.src = cfg.image;
      img.alt = '';
      img.width = 52;
      img.height = 52;
      img.loading = 'lazy';
      row.appendChild(img);
    }
    var body = el('div', 'hrs__body');
    body.appendChild(el('p', 'hrs__q', t.question));
    var price = el('p', 'hrs__price');
    price.appendChild(el('b', '', cfg.price));
    if (cfg.compare) price.appendChild(el('s', '', cfg.compare));
    body.appendChild(price);
    row.appendChild(body);
    box.appendChild(row);

    var actions = el('div', 'hrs__actions');
    var yes = button('hrs__btn--main', t.yes);
    var info = button('', t.info);
    var no = button('hrs__btn--ghost', t.no);
    yes.setAttribute('aria-expanded', 'false');
    info.setAttribute('aria-expanded', 'false');
    actions.appendChild(yes);
    actions.appendChild(info);
    actions.appendChild(no);
    box.appendChild(actions);

    // Panel "Sí": color + talla + añadir
    var pick = el('div', 'hrs__panel');
    pick.hidden = true;
    var fields = el('div', 'hrs__fields');
    var selects = (cfg.options || []).map(function (name, k) {
      var label = el('label', 'hrs__field');
      label.appendChild(el('span', '', name));
      var select = el('select');
      var seen = [];
      (cfg.variants || []).forEach(function (v) {
        var value = v.options[k];
        if (seen.indexOf(value) !== -1) return;
        seen.push(value);
        var opt = el('option', '', value);
        opt.value = value;
        select.appendChild(opt);
      });
      label.appendChild(select);
      fields.appendChild(label);
      return select;
    });
    pick.appendChild(fields);
    var add = button('hrs__btn--main hrs__add', t.add + ' · ' + cfg.price);
    pick.appendChild(add);
    var error = el('p', 'hrs__error', t.error);
    error.hidden = true;
    pick.appendChild(error);
    box.appendChild(pick);

    // Panel "Información": colores con foto + guía de tallas
    var infoPanel = el('div', 'hrs__panel');
    infoPanel.hidden = true;
    var colorIndex = 0;
    var colors = [];
    (cfg.variants || []).forEach(function (v) {
      var c = v.options[colorIndex];
      if (!colors.some(function (x) { return x.name === c; })) colors.push({ name: c, image: v.image });
    });
    if (colors.length) {
      infoPanel.appendChild(el('p', 'hrs__h', t.colors));
      var list = el('ul', 'hrs__colors');
      colors.forEach(function (c) {
        var li = el('li');
        if (c.image) {
          var im = el('img');
          im.src = c.image;
          im.alt = c.name;
          im.loading = 'lazy';
          li.appendChild(im);
        }
        li.appendChild(document.createTextNode(c.name));
        list.appendChild(li);
      });
      infoPanel.appendChild(list);
    }
    if ((cfg.sizes || []).length) {
      infoPanel.appendChild(el('p', 'hrs__h', t.sizes));
      var table = el('table', 'hrs__sizes');
      var tbody = el('tbody');
      cfg.sizes.forEach(function (line) {
        var parts = String(line).split(':');
        var tr = el('tr');
        tr.appendChild(el('td', '', parts.shift().trim()));
        tr.appendChild(el('td', '', parts.join(':').trim()));
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      infoPanel.appendChild(table);
    }
    if (t.note) infoPanel.appendChild(el('p', 'hrs__note', t.note));
    if (cfg.url && t.more) {
      var more = el('a', 'hrs__more', t.more);
      more.href = cfg.url;
      infoPanel.appendChild(more);
    }
    box.appendChild(infoPanel);

    // Solo deja elegir tallas que existen para el color elegido.
    function syncSizes() {
      selects.forEach(function (select, k) {
        if (k === 0) return;
        Array.prototype.forEach.call(select.options, function (opt) {
          opt.disabled = !(cfg.variants || []).some(function (v) {
            return v.available && v.options[k] === opt.value && selects.every(function (s, i) { return i >= k || v.options[i] === s.value; });
          });
        });
        if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
          var first = Array.prototype.find.call(select.options, function (o) { return !o.disabled; });
          if (first) select.value = first.value;
        }
      });
    }
    selects.forEach(function (s) { s.addEventListener('change', syncSizes); });
    syncSizes();

    function chosen() {
      var values = selects.map(function (s) { return s.value; });
      return (cfg.variants || []).find(function (v) {
        return v.available && values.every(function (value, i) { return v.options[i] === value; });
      });
    }
    function toggle(btn, panel, other, otherBtn) {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { other.hidden = true; otherBtn.setAttribute('aria-expanded', 'false'); }
    }

    yes.addEventListener('click', function () { toggle(yes, pick, infoPanel, info); });
    info.addEventListener('click', function () { toggle(info, infoPanel, pick, yes); });
    no.addEventListener('click', function () {
      dismiss();
      box.remove();
    });
    add.addEventListener('click', function () {
      var v = chosen();
      if (!v) return;
      add.disabled = true;
      error.hidden = true;
      addToCart(v.id)
        .then(function () { box.remove(); card = null; })
        .catch(function () { error.hidden = false; })
        .then(function () { add.disabled = false; });
    });
    return box;
  }

  function addToCart(id) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      return actions.updateCart({ lines: [{ merchandiseId: String(id), quantity: 1 }] }, { event: { context: 'product' } })
        .then(function (result) {
          if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
        });
    }
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.reload();
    });
  }

  function wrappers() {
    return Array.prototype.filter.call(document.querySelectorAll('.cart-items__wrapper'), function (w) {
      return !!w.querySelector('form.cart-form');
    });
  }

  function remove() {
    if (card && card.isConnected) card.remove();
  }

  function update() {
    if (busy) { queued = true; return; }
    cfg = readCfg();
    if (!cfg) { remove(); return; }
    busy = true;
    // Se consulta el carrito aunque esté vacío o cerrado: así, cuando ya no
    // queda ningún pijama, se olvida el "No, gracias" y la próxima vez que
    // añada un pijama vuelve a salir la sugerencia.
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasTrigger = items.some(function (it) { return it.handle === cfg.trigger; });
        var hasAddon = items.some(function (it) { return it.product_id === cfg.addonId; });
        if (!hasTrigger) { undismiss(); remove(); card = null; return; }
        if (hasAddon || dismissed()) { remove(); return; }
        var ws = wrappers();
        if (!ws.length) { remove(); return; }
        if (!card) card = buildCard();
        var target = ws.filter(function (w) { return w.closest('dialog[open]'); })[0] || ws[0];
        var form = target.querySelector('form.cart-form');
        if (card.parentNode !== target || card.previousElementSibling !== form) {
          form.insertAdjacentElement('afterend', card);
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 200);
  }

  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (!t.closest) continue;
      if ((card && card.contains(t)) || t.closest('[data-nrv3d]')) continue;
      if (t.closest('.cart-items__wrapper') || (t.querySelector && t.querySelector('.cart-items__wrapper'))) { schedule(); return; }
      if (t.nodeName === 'DIALOG' || t.closest('cart-drawer-component')) { schedule(); return; }
    }
  });

  function start() {
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    document.addEventListener('cart:update', schedule);
    document.addEventListener('shopify:section:load', function () { remove(); card = null; schedule(); });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
